// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ordini-fornitori?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string|null","stato":"BOZZA|EMESSO|ANNULLATO","dataEmissione":"string|null","createdAt":"string","fornitoreRagioneSociale":"string|null","fornitore":{"id":"number","ragioneSociale":"string"},"righeCommessa":"number","importoCommessa":"number","importoCommessaCompleto":"boolean"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/rda/da-ordinare?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"chiave":"string","descrizione":"string","totaleDaOrdinare":"number","sorgenti":[{"rigaRdaId":"number","residuo":"number"}]}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ordini?commessaId={id}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","totale":"string","importoTotale":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/sal?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string|null","stato":"string","importoTotale":"string","dataEmissione":"string|null","dataApprovazione":"string|null"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/distinte?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"number","tipo":"MERCE|LAVORAZIONI","addebito":"NOSTRO|CLIENTE","stato":"BOZZA|CONFERMATA","_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/fabbisogni/merce?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"chiave":"string","descrizione":"string","unitaMisura":"string","quantita":"number","quantitaEvasa":"number","residua":"number","giacenza":"number|null"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini-fornitori/:id/emetti',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"EMESSO","numero":"string","dataEmissione":"string"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
